import React, { useState } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import Stripe from "../components/Stripe";
import { useLocation } from "react-router-dom";
const Payment = () => {
  const {
    state: { price, items, orderId },
  } = useLocation();
  const [paymentMethod, setPaymentMethod] = useState("stripe");
  return (
    <div>
      <Headers />
      <section className="bg-[#eeeeee]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-16">
          <div className="flex flex-wrap md:flex-col-reverse">
            <div className="w-7/12 md:w-full">
              <div className="pr-2 md:pr-0">
                <div className="flex flex-wrap">
                  <div
                    onClick={() => setPaymentMethod("stripe")}
                    className={`w-[50%] border-r cursor-pointer py-5 px-3 rounded-t-2xl ${
                      paymentMethod === "stripe"
                        ? "bg-white border border-mainColor"
                        : "bg-mainColor/50"
                    }`}
                  >
                    <div className="flex flex-col gap-[3px] justify-center items-center">
                      <img
                        className="w-auto h-14"
                        src={`${process.env.REACT_APP_CLIENT_URL}/images/payment/stripe.png`}
                        alt="stripe"
                      />
                      <span className="text-slate-600">Stripe</span>
                    </div>
                  </div>
                  <div
                    onClick={() => setPaymentMethod("cib")}
                    className={`w-[50%] border-r cursor-pointer py-5 px-3 rounded-t-2xl ${
                      paymentMethod === "cib"
                        ? "bg-white border border-mainColor"
                        : "bg-mainColor/50"
                    }`}
                  >
                    <div className="flex flex-col gap-[3px] justify-center items-center">
                      <img
                        className="w-auto h-14"
                        src={`${process.env.REACT_APP_CLIENT_URL}/images/payment/cib.png`}
                        alt="cib"
                      />
                      <span className="text-slate-600">CIB</span>
                    </div>
                  </div>
                </div>
                {paymentMethod === "stripe" && (
                  <div className="w-full px-4 py-8 bg-white shadow-sm rounded-b-2xl border border-mainColor">
                    <h1 className="text-md">
                      Payer avec les cartes bancaires Visa ou Mastercard, votre
                      commande a été passée avec succès, veuillez contacter le
                      vendeur pour finaliser le paiement!
                    </h1>
                    <h1 className="text-md mb-5 text-right">
                      لقد تم تقديم طلبك بنجاح، يرجى الاتصال بالبائع لإتمام الدفع
                    </h1>
                    <button className="main-btn2">Payer - ادفع</button>
                    {/* <Stripe orderId={orderId} price={price} /> */}
                  </div>
                )}
                {paymentMethod === "cib" && (
                  <div className="w-full px-4 py-8 bg-white shadow-sm rounded-b-2xl border border-mainColor">
                    <h1 className="text-md">
                      Le CIB paiement sera bientôt disponible, votre commande a
                      été passée avec succès, veuillez contacter le vendeur pour
                      finaliser le paiement!
                    </h1>
                    <h1 className="text-md mb-5">
                      لقد تم تقديم طلبك بنجاح، يرجى الاتصال بالبائع لإتمام الدفع
                    </h1>
                    <button className="main-btn2">Payer - ادفع</button>
                  </div>
                )}
              </div>
            </div>
            <div className="w-5/12 md:w-full">
              <div className="pl-2 md:pl-0 md:mb-0">
                <div className="bg-white shadow p-5 mb-5 rounded-2xl text-slate-600 flex flex-col gap-3 border border-mainColor">
                  <h2>Résumé de la commande</h2>
                  <div className="flex justify-between items-center">
                    <span>{items} articles et frais de taxes inclus</span>
                    <span>{price} DA</span>
                  </div>
                  <div className="flex justify-between items-center font-semibold">
                    <span>Montant total</span>
                    <span className="text-lg text-green-500 font-bold">
                      {price} DA
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Payment;
